import { httpRequest } from "../../http";

export class CommandReplaceBrandAsset {
    async run(organizationId: string, brandId: string, assetId: number, file: File) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/assets/${assetId}`;
        const form = new FormData();
        form.append("file", file);
        return await httpRequest<any>(url, { method: "POST", body: form });
    }
}
